import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

/**
 * Ícone do carrinho — presente nas páginas públicas.
 *
 * REGRA (2026-07-26): só aparece quando existe pelo menos um item no carrinho.
 * Enquanto o carrinho está vazio, o botão é escondido para não poluir o
 * cabeçalho. Renderiza apenas o ícone (sem o texto "Carrinho"), com um badge
 * de contagem sobreposto.
 */
export default function CartButton({ className = "" }) {
  const { count } = useCart();
  if (!count) return null;
  return (
    <Link
      to="/carrinho"
      data-testid="cart-button"
      title={`Carrinho (${count} ${count === 1 ? "artigo" : "artigos"})`}
      aria-label={`Abrir carrinho — ${count} ${count === 1 ? "artigo" : "artigos"}`}
      className={`relative inline-flex items-center justify-center w-10 h-10 border border-[#222225] hover:border-[#FF3B00] text-[#C9C9CF] hover:text-white transition-colors ${className}`}
    >
      <ShoppingCart className="w-4 h-4" strokeWidth={1.8} />
      <span
        data-testid="cart-count"
        className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 bg-[#FF3B00] text-black text-[10px] font-bold flex items-center justify-center rounded-full"
      >
        {count}
      </span>
    </Link>
  );
}
